import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// Use relative URLs for API calls to avoid cross-origin redirect issues
// The Kubernetes ingress routes /api/* to the backend automatically
export const API_BASE = "/api";

// Create axios instance with auth interceptor
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Add auth token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("session_token");
      localStorage.removeItem("user");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export const setAuth = (token, user) => {
  localStorage.setItem("session_token", token);
  localStorage.setItem("user", JSON.stringify(user));
  // Set cookie that survives cross-origin redirects
  document.cookie = `session_token=${token}; path=/; max-age=${7 * 24 * 3600}; SameSite=None; Secure`;
};

export const clearAuth = () => {
  localStorage.removeItem("session_token");
  localStorage.removeItem("user");
  document.cookie = "session_token=; path=/; max-age=0; SameSite=None; Secure";
};

export const getStoredUser = () => {
  try {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
};

export const isAuthenticated = () => {
  return !!localStorage.getItem("session_token");
};

export default api;
